<app-prime-dialog [visible]="visible()" [pHeader]="true" [closable]="showCancelButton()"
  [styles]="{'width': '90%', 'max-width': '50rem'}" (dialogHide)="onCancel()">
  <div class="w-full" dialog-header>
    <h2 class="text-center">Cambiar contraseña</h2>

    <div class="alert alert-danger text-center" *ngIf="showError()">
      {{message()}}
    </div>
  </div>
  <motor-calculo-reset-password [showOldPasswordInput]="true"
    [initialOldPassword]="initialOldPassword()"
    (formValue)="onSubmit($event)"></motor-calculo-reset-password>
</app-prime-dialog>
